module.exports = __webpack_public_path__ + "static/img/horse.c427d63.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/other/thumbnail/horse.png
// module id = pZC3
// module chunks = 0